export default {
    'primary':'#f37b22',
    'white':'#fff',
}